'use client';
import Input from "./Input.js";
export default Input;